import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { EventoTemplate } from './pages/evento-template/evento-template';
import { ActividadPage } from './pages/actividad/actividad';
import { ReservarActividadPage } from './pages/reservar-actividad/reservar-actividad';
import { ComprarVagonPage } from './pages/comprar-vagon/comprar-vagon';
import { ComprarLocalidadPage } from './pages/comprarlocalidad/comprarlocalidad';
import { CheckoutComponent } from './pages/checkout/checkout';
import { CheckoutPaymentWaitingComponent } from './pages/checkout-payment-waiting/checkout-payment-waiting';
import { PayphoneConfirmComponent } from './pages/payments/payphone-confirm/payphone-confirm';
import { PayphoneCancelComponent } from './pages/payments/payphone-cancel/payphone-cancel';
import { LoginComponent } from './pages/login/login';
import { RegisterComponent } from './pages/register/register';
import { ActivateAccountComponent } from './pages/activate-account';
import { ResendActivationComponent } from './pages/resend-activation/resend-activation';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password';
import { ResetPasswordComponent } from './pages/reset-password/reset-password';
import { ChangePasswordComponent } from './pages/change-password/change-password';
import { NotFoundComponent } from './pages/not-found';
import { ProfileComponent } from './pages/profile/profile';
import { PrintInvoiceComponent } from './pages/print-invoice/print-invoice';
import { MaintenanceComponent } from './pages/maintenance/maintenance';
import { guestSessionGuard } from './core/guards/guest-session-guard';
import { maintenanceGuard } from './core/guards/maintenance.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { 
    path: '', 
    component: Home,
    canActivate: [maintenanceGuard, guestSessionGuard]

  },
  { 
    path: 'evento/:url_slug', 
    component: EventoTemplate,
    pathMatch: 'full',
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'evento/:url_slug/actividad/:slug_actividad',
    component: ActividadPage,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'evento/:url_slug/actividad/:slug_actividad/comprar',
    component: ReservarActividadPage,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'evento/:url_slug/actividad/:slug_actividad/comprar/:tipoticketid',
    component: ComprarVagonPage,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'evento/:url_slug/seatmap/comprar/:tipoticketid',
    component: ComprarLocalidadPage,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'evento/:url_slug/checkout', 
    component: CheckoutComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'evento/:url_slug/checkout-payment-waiting', 
    component: CheckoutPaymentWaitingComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'payments/payphone/confirm', 
    component: PayphoneConfirmComponent,
    canActivate: [maintenanceGuard]
  },
  { 
    path: 'payments/payphone/cancel', 
    component: PayphoneCancelComponent,
    canActivate: [maintenanceGuard]
  },
  { 
    path: 'login', 
    component: LoginComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'register', 
    component: RegisterComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'resend-activation',
    component: ResendActivationComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'activate-account', 
    component: ActivateAccountComponent,
    canActivate: [maintenanceGuard, guestSessionGuard]
  },
  { 
    path: 'profile', 
    component: ProfileComponent,
    canActivate: [maintenanceGuard, authGuard]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [maintenanceGuard, authGuard]
  },
  { 
    path: 'print-invoice/:facturaid', 
    component: PrintInvoiceComponent
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];